import Autocomplete from "./Autocomplete";

export default class AutocompleteLocationHandler {

    constructor(selector) {
        this.$plugin = $(selector)
        let $plugin = this.$plugin
        if ($plugin.length === 0) {
            return false
        }

        // Configuration for all location fields
        this.fields = {
            sfLocation: {
                inputSelector: '[data-sfLocationDataInput]',
                selectSelector: '[data-sfLocationDataSelect]',
                matchMode: 'contains',
                dataAttribute: 'data-locationName',
                fillFields: ['street', 'postalcode', 'city', 'phone', 'email']
            },
            street: {
                inputSelector: '[data-locationStreetData]',
                selectSelector: '[data-locationStreetDataSelect]',
                matchMode: 'contains',
                dataAttribute: 'data-street',
                fillFields: ['sfLocation', 'postalcode', 'city', 'phone', 'email']
            },
            postalcode: {
                inputSelector: '[data-locationPostalcodeData]',
                selectSelector: '[data-locationPostalcodeDataSelect]',
                matchMode: 'startsWith',
                dataAttribute: 'data-zipcode',
                fillFields: ['sfLocation', 'street', 'city', 'phone', 'email']
            },
            city: {
                inputSelector: '[data-locationCityData]',
                selectSelector: '[data-locationCityDataSelect]',
                matchMode: 'contains',
                dataAttribute: 'data-city',
                fillFields: ['sfLocation', 'street', 'postalcode', 'phone', 'email']
            }
        }

        // Initialize autocomplete instances
        Object.values(this.fields).forEach(field => {
            new Autocomplete(field.inputSelector, field.selectSelector, false, field.matchMode);
        });

        // Get DOM elements
        this.elements = {
            sfLocation: {
                input: document.querySelector('[data-sfLocationDataInput]'),
                select: document.querySelector('[data-sfLocationDataSelect]')
            },
            street: {
                input: document.querySelector('[data-locationStreetData]'),
                select: document.querySelector('[data-locationStreetDataSelect]')
            },
            postalcode: {
                input: document.querySelector('[data-locationPostalcodeData]'),
                select: document.querySelector('[data-locationPostalcodeDataSelect]')
            },
            city: {
                input: document.querySelector('[data-locationCityData]'),
                select: document.querySelector('[data-locationCityDataSelect]')
            },
            phone: {
                input: document.querySelector('[data-locationPhoneData]')
            },
            email: {
                input: document.querySelector('[data-locationEmailData]')
            }
        }

        this.init()
    }

    init() {
        // Hide all select dropdowns
        Object.entries(this.elements).forEach(([key, element]) => {
            if (element.select) {
                element.select.style.display = 'none';
            }
        });

        // Add event listeners for fields with autocomplete
        ['sfLocation', 'street', 'postalcode', 'city'].forEach(fieldName => {
            const element = this.elements[fieldName];

            element.input.addEventListener('input', () => {
                this.handleFieldChange(fieldName);
            }, false);

            if (element.select) {
                element.select.addEventListener('change', () => {
                    this.handleFieldChange(fieldName);
                }, false);
            }
        });
    }

    handleFieldChange(fieldName) {
        const element = this.elements[fieldName];
        if (!element.select) {
            return;
        }

        const selectedOption = element.select.options[element.select.selectedIndex];

        // Get the value to compare based on field type
        let compareValue = this.getCompareValue(fieldName, selectedOption);

        if (!compareValue || element.input.value.toUpperCase() !== compareValue.toUpperCase()) {
            return;
        }

        // Auto-fill other fields
        const fillConfig = {
            sfLocation: () => selectedOption.getAttribute('data-locationName'),
            street: () => {
                const street = selectedOption.getAttribute('data-street');
                const houseNumber = selectedOption.getAttribute('data-houseNumber');
                return street ? street + (houseNumber ? ' ' + houseNumber : '') : null;
            },
            postalcode: () => selectedOption.getAttribute('data-zipcode'),
            city: () => selectedOption.getAttribute('data-city'),
            phone: () => selectedOption.getAttribute('data-phone'),
            email: () => selectedOption.getAttribute('data-email')
        };

        // Fill all other fields
        this.fields[fieldName].fillFields.forEach(targetField => {
            const value = fillConfig[targetField]();
            if (value && this.elements[targetField]) {
                this.elements[targetField].input.value = value;
            }
        });
    }

    getCompareValue(fieldName, selectedOption) {
        switch (fieldName) {
            case 'sfLocation':
                return selectedOption.getAttribute('data-locationName');
            case 'street':
                const street = selectedOption.getAttribute('data-street');
                const houseNumber = selectedOption.getAttribute('data-houseNumber');
                return street ? street + (houseNumber ? ' ' + houseNumber : '') : null;
            case 'postalcode':
                return selectedOption.getAttribute('data-zipcode');
            case 'city':
                return selectedOption.getAttribute('data-city');
            default:
                return null;
        }
    }
}